// «الجرد اليومي» strings. Merged into translations by i18n.js.
// Keys are dk_*; both languages must carry the same key set.
// `{name}` tokens are filled with `fmt()` from ./dkUtils (t() has no interpolation).
export const DK_STRINGS = {
    ar: {
        // hub section + shell
        dk_subtitle: "جرد يومي للأصناف الرئيسية في كل فرع، ومقارنة المستخدم بالمبيعات",
        dk_tab_day: "اليوم",
        dk_tab_month: "الشهر",
        dk_tab_variance: "الفروقات",
        dk_tab_reconcile: "المطابقة الشهرية",
        dk_tab_items: "الأصناف",
        dk_tab_setup: "الإعدادات",
        dk_loading: "جارٍ التحميل…",
        dk_not_ready: "تعذّر تحميل الجرد اليومي. حاول مرة أخرى",
        dk_no_location: "لا يوجد فرع مرتبط بحسابك للجرد اليومي. اطلب من المسؤول تحديد «مواقع الجرد»",
        dk_retry: "إعادة المحاولة",
        dk_offline_error: "تعذّر الاتصال. تحقق من الشبكة وأعد المحاولة",
        dk_offline_not_saved: "لم يُحفظ — انقطع الاتصال. ما كتبته محفوظ على هذا الجهاز",
        dk_select_location: "اختر الفرع",
        dk_all_locations: "كل الفروع",
        dk_location: "الفرع",
        dk_item: "الصنف",
        dk_total: "المجموع",
        dk_inactive: "غير نشط",
        dk_active: "نشط",
        dk_unit_kg: "كيلو",
        dk_unit_pc: "حبة",
        dk_qty_placeholder: "—",
        dk_save: "حفظ",
        dk_saving: "جارٍ الحفظ…",
        dk_cancel: "إلغاء",
        dk_close: "إغلاق",

        // day sheet
        dk_today: "اليوم",
        dk_yesterday: "أمس",
        dk_edit_from_hint: "يمكنك التسجيل من {from} حتى اليوم",
        dk_opening: "الافتتاحي",
        dk_opening_none: "لا يوجد رصيد افتتاحي",
        dk_opening_src_yesterday: "من إغلاق أمس",
        dk_opening_src_prev_day: "من إغلاق {day}",
        dk_opening_src_count: "من جرد {month}",
        dk_opening_count_submitted: "مُرسَل ولم يُعتمد بعد",
        dk_opening_auto_zero: "اعتُبر صفراً في الجرد",
        dk_opening_src_override: "معدّل يدوياً",
        dk_received: "المستلم",
        dk_closing: "الإغلاق",
        dk_sent: "المحوَّل لفرع",
        dk_sent_to: "إلى فرع",
        dk_sent_to_none: "بدون تحديد",
        dk_sent_to_other: "فرع آخر",
        dk_more: "المزيد",
        dk_note: "ملاحظة",
        dk_note_ph: "اختياري",
        dk_packs: "عبوات",
        dk_loose: "مفتوح",
        dk_pack_hint: "{pack} = {n} {unit}",
        dk_not_counted: "لم يُجرد",
        dk_used: "المستخدم",
        dk_theo: "حسب المبيعات",
        dk_variance: "الفرق",
        dk_flag: "فرق كبير",
        dk_theo_none: "بانتظار المبيعات",
        dk_theo_no_pos: "بلا ربط بالمبيعات",
        dk_theo_unlinked: "بلا ربط بالوصفات",
        dk_used_no_opening: "بلا افتتاحي",
        dk_used_no_closing: "بلا إغلاق",
        dk_multi_day: "يغطي {n} يوم",
        dk_explained_line: "منها هدر وأكل عمال {q} {unit} · الفرق قبل خصمها {v}",
        dk_state_no_sales: "لا مبيعات مسجّلة لهذا اليوم",
        dk_state_not_synced: "مبيعات هذا اليوم لم تصل بعد من نقاط البيع — تصل عادةً بعد الساعة ٥ صباحاً",
        dk_state_no_pos_id: "الفرع غير مربوط بنقاط البيع، فلا تُحسب الكمية حسب المبيعات",
        dk_coverage_unmatched: "{n} من الكميات المباعة بلا وصفة، فالكمية حسب المبيعات أقل من الحقيقة",
        dk_coverage_unit_issues: "{n} سطر وصفة بوحدة غير معروفة لم يُحتسب",
        dk_reason_future: "لا يمكن التسجيل ليوم لم يأتِ بعد",
        dk_reason_window: "انتهت مدة التعديل لهذا اليوم (التسجيل متاح من {from})",
        dk_reason_read_only: "لديك صلاحية العرض فقط",
        dk_reason_not_home: "لا تسجّل الجرد لهذا الفرع — للعرض فقط",
        dk_reason_inactive: "الفرع غير نشط",
        dk_reason_locked: "هذا اليوم للعرض فقط",
        dk_draft_restored: "استُعيدت تعديلات لم تُحفظ",
        dk_draft_locked: "{n} تعديل لم يُحفظ ولا يمكن حفظه الآن",
        dk_stamp_saved: "آخر حفظ: {by}",
        dk_no_items: "لا أصناف للجرد اليومي",
        dk_excluded_n: "{n} صنف لا يُجرد في هذا الفرع",
        dk_counted_suffix: "صنف جُرد",
        dk_flags_n: "{n} فرق يحتاج مراجعة",
        dk_unsaved_n: "{n} لم يُحفظ",
        dk_saved_n: "حُفظ {n} صنف",
        dk_nothing_changed: "لا تغييرات للحفظ",
        dk_line_stale: "لم يُحفظ: سُجّل جرد هذا اليوم من جهاز آخر بعد فتحك للصفحة. حدّثنا الصفحة بآخر الأرقام وأبقينا تعديلاتك — راجعها ثم اضغط «حفظ» مرة أخرى",
        dk_line_stale_line: "تغيّر هذا الصنف من جهاز آخر — الأرقام المعروضة هي الأحدث مع تعديلاتك، راجعها قبل الحفظ",
        dk_warn_W1: "الإغلاق أكبر من الافتتاحي + المستلم — هل نسيت استلاماً؟",
        dk_warn_W3: "المستلم ليس عدداً كاملاً من العبوات — تأكد من العدد",

        // opening override
        dk_override_btn: "تعديل",
        dk_override_title: "تعديل الرصيد الافتتاحي",
        dk_override_hint: "يُستخدم بدلاً من إغلاق اليوم السابق أو الجرد الشهري، ويُسجَّل باسمك مع السبب",
        dk_override_current: "الحالي",
        dk_override_value: "الرصيد الافتتاحي الجديد",
        dk_override_reason: "السبب",
        dk_override_reason_min: "٥ أحرف على الأقل",
        dk_override_confirm: "حفظ التعديل",
        dk_override_clear: "إلغاء التعديل",
        dk_override_saved: "تم تعديل الرصيد الافتتاحي",
        dk_override_cleared: "أُلغي التعديل وعاد الرصيد المحسوب",

        // month grid + day detail
        dk_mode_used: "المستخدم",
        dk_mode_theoretical: "حسب المبيعات",
        dk_mode_variance: "الفرق",
        dk_mode_variance_hint: "الفرق = المستخدم − حسب المبيعات − الهدر وأكل العمال المسجّل",
        dk_month_legend: "«·» لم يُجرد أو لا رقم بعد · الأحمر فرق يحتاج مراجعة · النقطة تحت اليوم: مبيعاته لم تصل",
        dk_month_legend_counter: "«·» لم يُجرد أو لا رقم بعد · اضغط الخانة لتفاصيل اليوم",
        dk_month_days_missing_sales: "{n} يوم بلا مبيعات من نقاط البيع، فلا يُحسب فرقها",
        dk_panel_title: "تفاصيل اليوم",
        dk_panel_open_day: "فتح في «اليوم»",

        // variance board
        dk_range_month: "شهر",
        dk_range_custom: "فترة",
        dk_range_from: "من",
        dk_range_to: "إلى",
        dk_range_invalid: "اختر فترة صحيحة تنتهي اليوم أو قبله",
        dk_no_flags: "لا فروقات تحتاج مراجعة",
        dk_days_missing: "ناقص {n} يوم",
        dk_variance_empty: "لا بيانات لهذه الفترة",
        dk_variance_legend: "الرقم هو الفرق بعد خصم الهدر وأكل العمال، وتحته نسبته من «حسب المبيعات». الأحمر تجاوز الحد. اضغط الخانة لفتح شهر الفرع.",

        // export
        dk_export: "تصدير Excel",
        dk_exporting: "جارٍ التصدير…",
        dk_exported: "تم تنزيل الملف",
        dk_export_failed: "تعذّر التصدير",

        // monthly reconciliation
        dk_rec_opening: "رصيد أول الشهر",
        dk_rec_opening_src_override: "رصيد افتتاحي معدّل",
        dk_rec_opening_src_count: "جرد الشهر السابق",
        dk_rec_closing: "الإغلاق",
        dk_rec_closing_src_count: "جرد الشهر",
        dk_rec_closing_src_daily: "آخر إغلاق يومي",
        dk_rec_explained: "هدر وأكل عمال",
        dk_rec_last_daily: "آخر إغلاق يومي",
        dk_rec_stock_count: "الجرد",
        dk_rec_month_end_diff: "فرق نهاية الشهر",
        dk_rec_value_sar: "قيمة الفرق",
        dk_rec_sar_total: "قيمة الفروقات",
        dk_rec_empty: "لا بيانات لهذا الشهر",
        dk_rec_legend: "رصيد أول الشهر هو الرصيد الافتتاحي المعدّل ليوم ١ إن وُجد، وإلا جرد الشهر السابق. الإغلاق هو جرد الشهر إن أُرسل أو اعتُمد، وإلا آخر إغلاق يومي. فرق نهاية الشهر = آخر إغلاق يومي − جرد الشهر، للمعلومية فقط.",

        // items
        dk_items_intro: "الأصناف التي تُجرد يومياً في الفروع. اربط كل صنف بمكوّنات الوصفات ليُحسب «حسب المبيعات».",
        dk_items_edit: "تعديل الصنف",
        dk_items_name_ar: "الاسم بالعربية",
        dk_items_name_en: "الاسم بالإنجليزية",
        dk_items_section_pack: "العبوة (مساعد العدّ)",
        dk_items_pack_unit: "اسم العبوة",
        dk_items_pack_unit_ph: "مثل: كرتون 24",
        dk_items_pack_size: "الوحدات في العبوة",
        dk_items_pack_hint: "اتركه فارغاً لصنف بلا عبوة. العبوة للمساعدة فقط، ويبقى إدخال المفتوح متاحاً دائماً.",
        dk_items_recipe_keys: "مكوّنات الوصفات",
        dk_items_recipe_keys_hint: "الكمية حسب المبيعات = المبيعات × كمية هذه المكوّنات في كل وصفة (بمطابقة تامة للاسم).",
        dk_items_key_search: "ابحث عن مكوّن",
        dk_items_keys_unavailable: "تعذّر تحميل مكوّنات الوصفات",
        dk_items_no_keys: "لا نتائج",
        dk_items_key_broken: "هذه المكوّنات لم تعد في الوصفات الحالية — اضغط لإزالتها:",
        dk_items_recipes_n: "{n} وصفة",
        dk_items_flag_min: "أقل فرق يُعلَّم",
        dk_items_flag_min_hint: "اتركه فارغاً لاستخدام الإعداد العام ({n} {unit})",
        dk_items_excluded: "فروع لا يُجرد فيها",
        dk_items_excluded_hint: "لا يظهر الصنف للتسجيل في هذه الفروع",
        dk_items_sort_order: "الترتيب",
        dk_items_active: "الحالة",
        dk_items_saved: "تم حفظ الصنف",
        dk_items_no_changes: "لا تغييرات",
        dk_items_fix_fields: "صحّح الحقول المعلّمة",
        dk_items_err_required: "مطلوب",
        dk_items_err_pack_size: "أدخل عدداً أكبر من صفر",
        dk_items_err_min: "أدخل كمية صحيحة",
        dk_items_sc_unlinked: "غير مربوط بصنف الجرد الشهري بعد",
        dk_items_keys_n: "{n} مكوّن وصفة",
        dk_items_min_short: "أقل فرق {n} {unit}",
        dk_items_min_own: "خاص بالصنف",
        dk_items_excluded_short: "لا يُجرد في: {list}",
        dk_items_no_link: "غير مربوط بالوصفات — لا يُحسب «حسب المبيعات»",
        dk_items_broken_n: "{n} مكوّن لم يعد في الوصفات",
        dk_unit_class_kg: "يُجرد بالكيلو (بكسور)",
        dk_unit_class_pc: "يُجرد بالحبة (أعداد صحيحة)",

        // settings
        dk_setup_rules_title: "قاعدة الفروقات والحدود",
        dk_setup_rules_hint: "يُعلَّم السطر عندما يتجاوز الفرق النسبة من «حسب المبيعات» ويبلغ أقل كمية، معاً.",
        dk_setup_flag_pct: "نسبة الفرق",
        dk_setup_flag_pct_hint: "من الكمية حسب المبيعات",
        dk_setup_flag_min_kg_milli: "أقل فرق للأصناف بالكيلو",
        dk_setup_flag_min_kg_milli_hint: "أصغر فرق يُعلَّم لصنف بالكيلو",
        dk_setup_flag_min_pc_milli: "أقل فرق للأصناف بالحبة",
        dk_setup_flag_min_pc_milli_hint: "أصغر فرق يُعلَّم لصنف بالحبة",
        dk_setup_max_kg: "أكبر كمية مسموحة بالكيلو",
        dk_setup_max_kg_hint: "لكل خانة، لكشف أخطاء الإدخال",
        dk_setup_max_pc: "أكبر كمية مسموحة بالحبة",
        dk_setup_max_pc_hint: "لكل خانة، لكشف أخطاء الإدخال",
        dk_setup_counter_edit_days: "مدة تعديل الفرع",
        dk_setup_counter_edit_days_hint: "الأيام التي يعدّلها الفرع بما فيها اليوم (٢ = اليوم وأمس)",
        dk_setup_unit_pct: "٪",
        dk_setup_unit_days: "يوم",
        dk_setup_locations_title: "الفروع المشمولة",
        dk_setup_locations_hint: "الفروع التي تسجّل الجرد اليومي ({n})",
        dk_setup_saved: "تم حفظ الإعدادات",
        dk_setup_err_value: "أدخل رقماً صحيحاً",
        dk_setup_err_codes: "اختر فرعاً واحداً على الأقل",
    },
    en: {
        // hub section + shell
        dk_subtitle: "A daily count of the key items at each branch, with usage checked against sales",
        dk_tab_day: "Day",
        dk_tab_month: "Month",
        dk_tab_variance: "Variance",
        dk_tab_reconcile: "Monthly reconciliation",
        dk_tab_items: "Items",
        dk_tab_setup: "Settings",
        dk_loading: "Loading…",
        dk_not_ready: "The daily count could not be loaded. Try again",
        dk_no_location: "No branch is linked to your account for the daily count. Ask an admin to set your count locations",
        dk_retry: "Retry",
        dk_offline_error: "Could not connect. Check the network and retry",
        dk_offline_not_saved: "Not saved — the connection dropped. What you typed is kept on this device",
        dk_select_location: "Pick a branch",
        dk_all_locations: "All branches",
        dk_location: "Branch",
        dk_item: "Item",
        dk_total: "Total",
        dk_inactive: "Inactive",
        dk_active: "Active",
        dk_unit_kg: "kg",
        dk_unit_pc: "pcs",
        dk_qty_placeholder: "—",
        dk_save: "Save",
        dk_saving: "Saving…",
        dk_cancel: "Cancel",
        dk_close: "Close",

        // day sheet
        dk_today: "Today",
        dk_yesterday: "Yesterday",
        dk_edit_from_hint: "You can record from {from} to today",
        dk_opening: "Opening",
        dk_opening_none: "No opening balance",
        dk_opening_src_yesterday: "From yesterday's closing",
        dk_opening_src_prev_day: "From the closing of {day}",
        dk_opening_src_count: "From the {month} stock count",
        dk_opening_count_submitted: "submitted, not yet approved",
        dk_opening_auto_zero: "zero-filled in the count",
        dk_opening_src_override: "Set by hand",
        dk_received: "Received",
        dk_closing: "Closing",
        dk_sent: "Sent to a branch",
        dk_sent_to: "To branch",
        dk_sent_to_none: "Not specified",
        dk_sent_to_other: "Another branch",
        dk_more: "More",
        dk_note: "Note",
        dk_note_ph: "Optional",
        dk_packs: "Packs",
        dk_loose: "Loose",
        dk_pack_hint: "1 {pack} = {n} {unit}",
        dk_not_counted: "Not counted",
        dk_used: "Used",
        dk_theo: "By sales",
        dk_variance: "Variance",
        dk_flag: "Outlier",
        dk_theo_none: "Waiting for sales",
        dk_theo_no_pos: "No POS link",
        dk_theo_unlinked: "No recipe link",
        dk_used_no_opening: "No opening",
        dk_used_no_closing: "No closing",
        dk_multi_day: "Covers {n} days",
        dk_explained_line: "Of which waste & staff meals {q} {unit} · variance before them {v}",
        dk_state_no_sales: "No sales recorded for this day",
        dk_state_not_synced: "This day's sales have not arrived from the POS yet — they usually arrive after 5 AM",
        dk_state_no_pos_id: "The branch has no POS link, so usage by sales cannot be computed",
        dk_coverage_unmatched: "{n} units sold have no recipe, so «by sales» reads low",
        dk_coverage_unit_issues: "{n} recipe lines in an unknown unit were left out",
        dk_reason_future: "A day that has not come yet cannot be recorded",
        dk_reason_window: "The edit window for this day has closed (recording is open from {from})",
        dk_reason_read_only: "You can view only",
        dk_reason_not_home: "You do not record for this branch — view only",
        dk_reason_inactive: "The branch is inactive",
        dk_reason_locked: "This day is view-only",
        dk_draft_restored: "Unsaved edits restored",
        dk_draft_locked: "{n} unsaved edits cannot be saved now",
        dk_stamp_saved: "Last saved by {by}",
        dk_no_items: "No daily-count items",
        dk_excluded_n: "{n} items are not counted at this branch",
        dk_counted_suffix: "items counted",
        dk_flags_n: "{n} outliers to review",
        dk_unsaved_n: "{n} unsaved",
        dk_saved_n: "Saved {n} items",
        dk_nothing_changed: "Nothing to save",
        dk_line_stale: "Not saved: this day's count was saved on another device after you opened the page. The page now shows the latest figures with your edits kept — check them and press «Save» again",
        dk_line_stale_line: "Changed on another device — showing the latest figures with your edits; check before saving",
        dk_warn_W1: "Closing is above opening + received — a receipt missing?",
        dk_warn_W3: "Received is not a whole number of packs — check the count",

        // opening override
        dk_override_btn: "Change",
        dk_override_title: "Change the opening",
        dk_override_hint: "Used instead of the previous closing or the monthly count, and logged under your name with the reason",
        dk_override_current: "Current",
        dk_override_value: "New opening",
        dk_override_reason: "Reason",
        dk_override_reason_min: "At least 5 characters",
        dk_override_confirm: "Save change",
        dk_override_clear: "Remove the change",
        dk_override_saved: "Opening changed",
        dk_override_cleared: "Change removed; the computed opening is back",

        // month grid + day detail
        dk_mode_used: "Used",
        dk_mode_theoretical: "By sales",
        dk_mode_variance: "Variance",
        dk_mode_variance_hint: "Variance = used − by sales − recorded waste & staff meals",
        dk_month_legend: "«·» not counted or no figure yet · red is an outlier · a dot under a day: its sales have not arrived",
        dk_month_legend_counter: "«·» not counted or no figure yet · tap a cell for the day's detail",
        dk_month_days_missing_sales: "{n} days have no POS sales, so their variance is not computed",
        dk_panel_title: "Day detail",
        dk_panel_open_day: "Open in «Day»",

        // variance board
        dk_range_month: "Month",
        dk_range_custom: "Date range",
        dk_range_from: "From",
        dk_range_to: "To",
        dk_range_invalid: "Pick a valid range that ends today or earlier",
        dk_no_flags: "No outliers",
        dk_days_missing: "{n} days missing",
        dk_variance_empty: "No data for this period",
        dk_variance_legend: "The figure is the variance after waste & staff meals, with its % of «by sales» below. Red is over the limit. Tap a cell to open the branch's month.",

        // export
        dk_export: "Export to Excel",
        dk_exporting: "Exporting…",
        dk_exported: "File downloaded",
        dk_export_failed: "Export failed",

        // monthly reconciliation
        dk_rec_opening: "Month opening",
        dk_rec_opening_src_override: "opening override",
        dk_rec_opening_src_count: "last month's count",
        dk_rec_closing: "Closing",
        dk_rec_closing_src_count: "month count",
        dk_rec_closing_src_daily: "last daily closing",
        dk_rec_explained: "Waste & meals",
        dk_rec_last_daily: "Last daily closing",
        dk_rec_stock_count: "count",
        dk_rec_month_end_diff: "Month-end gap",
        dk_rec_value_sar: "Variance value",
        dk_rec_sar_total: "Variance value",
        dk_rec_empty: "No data for this month",
        dk_rec_legend: "Month opening is the day-1 opening override when there is one, else last month's stock count. Closing is the month's stock count once submitted or approved, else the last daily closing. Month-end gap = last daily closing − stock count, for information only.",

        // items
        dk_items_intro: "The items counted daily at the branches. Link each item to its recipe ingredients so «by sales» can be computed.",
        dk_items_edit: "Edit item",
        dk_items_name_ar: "Arabic name",
        dk_items_name_en: "English name",
        dk_items_section_pack: "Pack (counting helper)",
        dk_items_pack_unit: "Pack name",
        dk_items_pack_unit_ph: "e.g. carton 24",
        dk_items_pack_size: "Units per pack",
        dk_items_pack_hint: "Leave blank for an item without a pack. The pack is only a helper; loose entry always stays available.",
        dk_items_recipe_keys: "Recipe ingredients",
        dk_items_recipe_keys_hint: "By sales = sales × the quantity of these ingredients in each recipe (exact name match).",
        dk_items_key_search: "Search ingredients",
        dk_items_keys_unavailable: "Recipe ingredients could not be loaded",
        dk_items_no_keys: "No results",
        dk_items_key_broken: "These ingredients are no longer in the current recipes — tap to remove:",
        dk_items_recipes_n: "{n} recipes",
        dk_items_flag_min: "Smallest flagged variance",
        dk_items_flag_min_hint: "Leave blank to use the general setting ({n} {unit})",
        dk_items_excluded: "Branches that do not count it",
        dk_items_excluded_hint: "The item is not offered for entry at these branches",
        dk_items_sort_order: "Sort order",
        dk_items_active: "Status",
        dk_items_saved: "Item saved",
        dk_items_no_changes: "No changes",
        dk_items_fix_fields: "Fix the marked fields",
        dk_items_err_required: "Required",
        dk_items_err_pack_size: "Enter a number above zero",
        dk_items_err_min: "Enter a valid quantity",
        dk_items_sc_unlinked: "not linked to its stock-count item yet",
        dk_items_keys_n: "{n} recipe ingredients",
        dk_items_min_short: "min. variance {n} {unit}",
        dk_items_min_own: "own",
        dk_items_excluded_short: "not counted at: {list}",
        dk_items_no_link: "No recipe link — «by sales» is not computed",
        dk_items_broken_n: "{n} ingredients are no longer in the recipes",
        dk_unit_class_kg: "Counted in kilos (decimals)",
        dk_unit_class_pc: "Counted in pieces (whole numbers)",

        // settings
        dk_setup_rules_title: "Variance rule and limits",
        dk_setup_rules_hint: "A line is flagged when the variance is over the % of «by sales» and at least the minimum quantity, both together.",
        dk_setup_flag_pct: "Variance %",
        dk_setup_flag_pct_hint: "of usage by sales",
        dk_setup_flag_min_kg_milli: "Minimum variance, kilo items",
        dk_setup_flag_min_kg_milli_hint: "The smallest variance that flags a kilo item",
        dk_setup_flag_min_pc_milli: "Minimum variance, piece items",
        dk_setup_flag_min_pc_milli_hint: "The smallest variance that flags a piece item",
        dk_setup_max_kg: "Largest quantity allowed, kg",
        dk_setup_max_kg_hint: "Per field, to catch typing slips",
        dk_setup_max_pc: "Largest quantity allowed, pieces",
        dk_setup_max_pc_hint: "Per field, to catch typing slips",
        dk_setup_counter_edit_days: "Branch edit window",
        dk_setup_counter_edit_days_hint: "Days a branch may edit, today included (2 = today and yesterday)",
        dk_setup_unit_pct: "%",
        dk_setup_unit_days: "days",
        dk_setup_locations_title: "Branches included",
        dk_setup_locations_hint: "The branches that keep the daily count ({n})",
        dk_setup_saved: "Settings saved",
        dk_setup_err_value: "Enter a valid number",
        dk_setup_err_codes: "Pick at least one branch",
    },
};
